import React, { Component } from 'react';
import PropTypes from 'prop-types';
import warning from 'warning';

import TransitionComponent from './ExpandTransition';

function ExpandTransition(props) {
  return <TransitionComponent {...props} />;
}

const getStyles = (props) => {
  const styles = {
    root: {
      marginTop: -14,
      marginLeft: 14 + 13, // padding + (1/2 icon - 1)
      paddingLeft: 24 - (13 + 8),
      paddingRight: 16,
      overflow: 'hidden',
    },
  };

  if (!props.last) {
    styles.root.borderLeft = '2px solid #000';
  }

  return styles;
};

// eslint-disable-next-line react/prefer-stateless-function
class StepContent extends Component {
  render() {
    const {
      active,
      children,
      completed, // eslint-disable-line no-unused-vars
      last, // eslint-disable-line no-unused-vars
      icon, // eslint-disable-line no-unused-vars
      style,
      transition,
      transitionDuration,
      ...other
    } = this.props;
    const { stepper } = this.context;

    if (stepper.orientation !== 'vertical') {
      warning(
        false,
        'Material-UI: <StepContent /> is only designed for use with the vertical stepper.'
      );
      return null;
    }

    const styles = getStyles(this.props);
    const transitionProps = {
      enterDelay: transitionDuration,
      transitionDuration,
      open: active,
    };

    return (
      <div style={styles.root} {...other}>
        {React.createElement(
          transition,
          transitionProps,
          <div style={{ overflow: 'hidden' }}>{children}</div>
        )}
      </div>
    );
  }
}

StepContent.contextTypes = {
  stepper: PropTypes.object,
};

StepContent.defaultProps = {
  transition: ExpandTransition,
  transitionDuration: 450,
};

StepContent.propTypes = {
  /**
   * Expands the content
   */
  active: PropTypes.bool,
  /**
   * Step content
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  completed: PropTypes.bool,
  /**
   * @ignore
   */
  last: PropTypes.bool,
  /**
   * @ignore
   */
  icon: PropTypes.number,
  /**
   * Override the inline-style of the root element.
   */
  style: PropTypes.object,
  /**
   * ReactTransitionGroup component.
   */
  transition: PropTypes.func,
  /**
   * Adjust the duration of the content expand transition. Passed as a prop to the transition component.
   */
  transitionDuration: PropTypes.number,
};

export default StepContent;
